import { render, staticRenderFns } from "./scenicService.vue?vue&type=template&id=5252600f&scoped=true"
import script from "./scenicService.vue?vue&type=script&lang=js"
export * from "./scenicService.vue?vue&type=script&lang=js"
import style0 from "./scenicService.vue?vue&type=style&index=0&id=5252600f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252600f",
  null
  
)

export default component.exports